<template>
  <div class="layout">
    <header class="layout-header">
      <van-nav-bar
        :title="title"
        left-text="返回"
        left-arrow
        fixed
        :border="false"
        @click-left="onClickLeft"
      >
        <template #right>
          <slot name="right"></slot>
        </template>
      </van-nav-bar>
    </header>
    <main class="layout-main">
      <slot></slot>
    </main>
    <footer class="layout-footer" v-if="footerShow">
      <van-icon name="phone-o" />电话：{{ phone }}
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    footerShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    title() {
      return this.$route.meta.title;
    },
    phone() {
      return this.$store.state.stationInfo.phone;
    }
  },
  data() {
    return {};
  },
  methods: {
    onClickLeft() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss">
.layout {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &-header {
    height: rem(106);
    background: #1db475;

    .van-nav-bar {
      height: rem(106);
      background: #1db475;

      &__left {
        color: #fff;
      }

      &__text {
        font-size: rem(24);
        color: #fff;
      }

      &__title {
        color: #fff;
        font-size: rem(32);
      }

      &__right {
        margin-right: rem(10);

        .van-count-down {
          width: rem(60);
          height: rem(60);
          text-align: center;
          line-height: rem(60);
          border: 1px solid #fff;
          border-radius: 100%;
          font-size: rem(24);
          color: #fff;
        }
      }
    }

    .van-icon-arrow-left {
      font-size: rem(24);
      color: #fff;
    }
  }

  &-main {
    flex-shrink: 0;
    flex: 1;
    overflow: auto;
  }

  &-footer {
    padding: rem(20) 0;
    text-align: center;
    color: #c0c7cc;
    font-size: rem(24);

    .van-icon {
      vertical-align: middle;
      margin-right: rem(10);
      font-size: rem(28);
    }
  }
}
</style>
